import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants';
import type { GetStatusResponse } from '../../../common/types';

const getStatus = (): Promise<GetStatusResponse> => {
	return fetch(urls.wioc.status.url(), {
		method: 'GET',
	});
};

export { getStatus };
